import { apiClient } from '~/api/client';

export type UpdateParams = {
  id: string;
  type: ListSTI;
  attributes: {
    color: string;
    description: string;
    name: string;
    public: boolean;
    shared_user_ids?: number[];
    synced: boolean;
  };
};

export const update = async (params: UpdateParams) =>
  apiClient.put(`/lists/${params.id}`, { attributes: params.attributes, type: params.type });
